import React from "react";
import { FormattedMessage } from "react-intl";
import OutlinedButton from "../../../../ui/OutlinedButton/OutlinedButton";
import Panel from "../../../../ui/Panel/Panel";
import classes from "./SecurityMethodItem.module.scss";
import messages from "../module/messages";
import WelcomeCard from "../../../../ui/WelcomeCard/WelcomeCard";
import { TbDeviceMobile, TbUser, TbMail } from "react-icons/tb";

interface SecurityMethodItemProps {
  method: "mfaRequired" | "securityQuestionsRequired" | "uigpOTPRequired";
  onSelect: (
    method: "mfaRequired" | "securityQuestionsRequired" | "uigpOTPRequired"
  ) => void;
}

const METHOD_ICONS_MAP = {
  mfaRequired: <TbDeviceMobile />,
  uigpOTPRequired: <TbMail />,
  securityQuestionsRequired: <TbUser />,
};

function SecurityMethodItem({ method, onSelect }: SecurityMethodItemProps) {
  return (
    <div className={classes.panelWrapper}>
      <WelcomeCard
        title={<FormattedMessage {...messages[method]} />}
        desc={
          <FormattedMessage
            {...messages[(method + "Desc") as keyof typeof messages]}
          />
        }
        icon={METHOD_ICONS_MAP[method]}
        onCardClick={() => onSelect(method)}
        fixedHeight
      />
    </div>
  );
}

export default SecurityMethodItem;
